import { Routes } from '@angular/router';
import { AdminComponent } from './layout/admin/admin.component';
import { authGuard } from './core/guard/auth-guard';

export const routes: Routes = [
    //redireccion inicial
    {
        path:'',
        redirectTo:'/authentication/login',
        pathMatch:'full'
    },
    //rutas publicas
    {
        path:'authentication',
        loadComponent:()=> import('./layout/guest/guest.component').then(m=>m.GuestComponent),
        children:[
            {
        path: 'login',
        loadComponent: () =>
            import('./features/authentication/pages/login/login.component').then(m => m.LoginComponent),
                title: 'Iniciar Sesión'
            },
            {
                path: '',
                redirectTo: 'login',
                pathMatch: 'full'
            }
        ]
    },
    //rutas privadas
    {
        path: '',
        component: AdminComponent,
        canActivate: [authGuard], 
        children: [
        {
            path: 'dashboard',
            loadComponent: () => import('./features/dashboard/default/default.component')
            .then((c) => c.DefaultComponent),
            title: 'Dashboard'
        },
        {
            path: 'typography',
            loadComponent: () => 
            import('./demo/elements/typography/typography.component')
                .then((c) => c.TypographyComponent),
            title: 'Typography'
        },
        
        {
            path: 'doctor',
            loadChildren: () => 
                import('./features/doctor/doctor.routes')
                .then((m) => m.Doctor),
            title: 'Doctor'
        },
        {
            path: 'usuarios',
            loadChildren: () => 
                import('./features/usuarios/usuarios.routes')
                .then((m) => m.Usuarios),
            title: 'Usuarios'
        },
        {
            path: 'roles',
            loadChildren: () => 
                import('./features/roles/roles.routes')
                .then((m) => m.Roles),
            title: 'Rol'
        },
        {
            path: 'atencion',
            loadChildren: () => 
                import('./features/atencionpacientes/atencion.routes')
                .then((m) => m.Atencion),
            title: 'Atencion'
        },
        {
            path: 'atencionpaciente',
            // Rutas legadas (compatibilidad): antes estaba montado aquí el módulo de pacientes
            // Se redirige a la nueva estructura semántica /pacientes/*
            children: [
              { path: '', redirectTo: '/pacientes/lista', pathMatch: 'full' },
              { path: 'pacientes', redirectTo: '/pacientes/lista', pathMatch: 'full' },
              { path: 'pacientes/nuevo', redirectTo: '/pacientes/nuevo', pathMatch: 'full' },
              { path: 'pacientes/:id/editar', redirectTo: '/pacientes/:id/editar', pathMatch: 'full' },
            ],
            title: 'Atencion'
        },
        {
            // Ruta canónica: pacientes como módulo independiente
            path: 'pacientes',
            loadChildren: () => 
                import('./features/pacientes/pacientes.routes')
                .then((m) => m.Paciente),
            title: 'Pacientes'
        },
        {
            path: 'atenciones',
            loadChildren: () =>
                import('./features/atenciones/atenciones.routes')
                .then((m) => m.Atenciones),
            title: 'Atenciones'
        },
        {
            path: 'caja',
            loadChildren: () =>
                import('./features/caja/caja.routes')
                .then((m) => m.Caja),
            title: 'Caja'
        },
        {
            path: 'farmacia',
            loadChildren: () =>
                import('./features/farmacia/farmacia.routes')
                .then((m) => m.FarmaciaRoutes),
            title: 'Farmacia'
        },
        {
            path: 'internaciones',
            loadChildren: () =>
                import('./features/internaciones/internaciones.routes')
                .then((m) => m.Internaciones),
            title: 'Internaciones'
        },
        {
            path: 'servicios',
            loadChildren: () =>
                import('./features/servicios/servicios.routes')
                .then((m) => m.Servicios),
            title: 'Servicios'
        },
        {
            path: 'horarios',
            loadChildren: () =>
                import('./features/horarios/horarios.routes')
                .then((m) => m.Horarios),
            title: 'Horarios'
        },
        {
            path: 'citas',
            loadChildren: () =>
                import('./features/citas/citas.routes')
                .then((m) => m.Citas),
            title: 'Citas'
        },
        {
            path: 'historial-medico',
            loadChildren: () =>
                import('./features/historial/historial.routes')
                .then((m) => m.HistorialMedico),
            title: 'Historial Médico'
        },
        {
            path: 'reportes',
            loadChildren: () =>
                import('./features/reportes/reportes.routes')
                .then((m) => m.Reportes),
            title: 'Reportes'
        },
        {
            path: 'especialidades',
            loadChildren: () =>
                import('./features/especialidades/especialidades.routes')
                .then((m) => m.Especialidades),
            title: 'Especialidades'
        },
	        {
	            path: 'medicos',
	            loadChildren: () =>
	                import('./features/medicos/medicos.routes')
	                .then((m) => m.Medicos),
	            title: 'Médicos'
	        },
        {
            path: 'color',
            loadComponent: () => 
            import('./demo/elements/element-color/element-color.component')
                .then((c) => c.ElementColorComponent),
            title: 'Colors'
        },
        {
            path: 'sample-page',
            loadComponent: () => 
            import('./demo/other/sample-page/sample-page.component')
                .then((c) => c.SamplePageComponent),
            title: 'Sample Page'
        },
        {
            // Mantener /cirugias/* dentro del layout Admin (sidebar + navbar)
            // para que el comportamiento sea consistente con el resto de módulos.
            path: 'cirugias',
            loadChildren: () => import('./features/cirugias/cirugias.routes')
                .then((m) => m.CIRUGIAS_ROUTES),
            title: 'Cirugías'
        }
        ]
    } ,
    //paginas de error
    {
    path: 'acceso-denegado',
    loadComponent: () =>
      import('./shared/pages/acceso-denegado/acceso-denegado')
        .then(m => m.AccesoDenegado),
    title: 'Acceso Denegado'
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./shared/pages/error/error')
        .then(m => m.Error),
    title: 'Error'
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/pages/no-encontrado/no-encontrado')
        .then(m => m.NoEncontrado),
    title: 'Página no encontrada'
  }
]
